var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWrk5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 302,
    height: 115,
    viewBox: "0 0 302 115",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_485",
    "data-name": "Rectangle 485",
    width: 302,
    height: 115,
    transform: "translate(1478 3805)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_885",
    "data-name": "Rectangle 885",
    width: 106.671,
    height: 114.096,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_883",
    "data-name": "Rectangle 883",
    width: 106.672,
    height: 114.096,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_882",
    "data-name": "Rectangle 882",
    width: 106.671,
    height: 114.095,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_853",
    "data-name": "Rectangle 853",
    width: 31.033,
    height: 8.078,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_854",
    "data-name": "Rectangle 854",
    width: 31.033,
    height: 19.541,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_855",
    "data-name": "Rectangle 855",
    width: 2.792,
    height: 5.078,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_856",
    "data-name": "Rectangle 856",
    width: 1.099,
    height: 5.256,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_857",
    "data-name": "Rectangle 857",
    width: 2.732,
    height: 3.682,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_858",
    "data-name": "Rectangle 858",
    width: 2.435,
    height: 3.742,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_859",
    "data-name": "Rectangle 859",
    width: 2.826,
    height: 3.801,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_860",
    "data-name": "Rectangle 860",
    width: 1.455,
    height: 5.019,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_861",
    "data-name": "Rectangle 861",
    width: 3.118,
    height: 5.019,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_862",
    "data-name": "Rectangle 862",
    width: 3.267,
    height: 4.87,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_863",
    "data-name": "Rectangle 863",
    width: 3.296,
    height: 4.87,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_864",
    "data-name": "Rectangle 864",
    width: 1.01,
    height: 1.069,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_865",
    "data-name": "Rectangle 865",
    width: 1.01,
    height: 1.039,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_866",
    "data-name": "Rectangle 866",
    width: 13.868,
    height: 4.573,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_867",
    "data-name": "Rectangle 867",
    width: 0.594,
    height: 4.662,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_868",
    "data-name": "Rectangle 868",
    width: 2.524,
    height: 4.662,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_869",
    "data-name": "Rectangle 869",
    width: 2.702,
    height: 4.662,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_871",
    "data-name": "Rectangle 871",
    width: 5.256,
    height: 5.286,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_872",
    "data-name": "Rectangle 872",
    width: 13.185,
    height: 22.807,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_873",
    "data-name": "Rectangle 873",
    width: 13.215,
    height: 30.024,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_875",
    "data-name": "Rectangle 875",
    width: 4.811,
    height: 22.807,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_876",
    "data-name": "Rectangle 876",
    width: 23.524,
    height: 33.855,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_877",
    "data-name": "Rectangle 877",
    width: 5.286,
    height: 5.286,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_878",
    "data-name": "Rectangle 878",
    width: 14.849,
    height: 22.807,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_879",
    "data-name": "Rectangle 879",
    width: 37.002,
    height: 33.171,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-32"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_880",
    "data-name": "Rectangle 880",
    width: 16.868,
    height: 33.171,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_10",
    "data-name": "Mask Group 10",
    transform: "translate(-1478 -3805)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2255",
    "data-name": "Group 2255",
    transform: "translate(1575.664 3805.452)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_884",
    "data-name": "Rectangle 884",
    width: 31.033,
    height: 8.077,
    transform: "translate(38.095 86.495)",
    fill: "#cc4e1d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2254",
    "data-name": "Group 2254",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2253",
    "data-name": "Group 2253",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9540",
    "data-name": "Path 9540",
    d: "M36.047,73.241a3.46,3.46,0,1,1-3.475,3.445,3.448,3.448,0,0,1,3.475-3.445",
    transform: "translate(6.152 13.833)",
    fill: "#d70d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9541",
    "data-name": "Path 9541",
    d: "M42.437,73.241a3.46,3.46,0,1,1-3.445,3.445,3.454,3.454,0,0,1,3.445-3.445",
    transform: "translate(7.364 13.833)",
    fill: "#d70d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9542",
    "data-name": "Path 9542",
    d: "M48.862,73.241a3.46,3.46,0,1,1-3.475,3.445,3.448,3.448,0,0,1,3.475-3.445",
    transform: "translate(8.572 13.833)",
    fill: "#d70d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9543",
    "data-name": "Path 9543",
    d: "M55.252,73.241a3.46,3.46,0,1,1-3.445,3.445,3.454,3.454,0,0,1,3.445-3.445",
    transform: "translate(9.785 13.833)",
    fill: "#d70d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9544",
    "data-name": "Path 9544",
    d: "M32.048,79.534v4.009a15.517,15.517,0,1,0,31.033,0V79.534Z",
    transform: "translate(6.053 15.021)",
    fill: "#d70d1b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9545",
    "data-name": "Path 9545",
    d: "M41.573,81.907h1.485v5.761c0,2.079-1.6,3.148-3.564,3.148a3.216,3.216,0,0,1-3.474-3.089V85.471h1.4V87.52c0,1.188.861,1.842,2.108,1.842a1.883,1.883,0,0,0,2.05-1.812Z",
    transform: "translate(6.803 15.47)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9546",
    "data-name": "Path 9546",
    d: "M42.715,82.107h1.513l1.366,5.286s.03.238.178.238c.208,0,.208-.238.208-.238V82.107H47.5v4.544c0,.98,0,.98,1.04.98h6.206s.089-2.465-1.99-2.465c-1.009,0-1.515.623-1.515,1.158H49.692s-.058-2.465,2.94-2.465c3.12,0,3.713,2.465,3.713,5.137h-7.81c-1.189,0-1.248-.623-1.486-.623S46.842,89,45.8,89H42.715l.594-1.425h.8Z",
    transform: "translate(8.068 15.507)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9547",
    "data-name": "Path 9547",
    d: "M79.1,59.908a2.466,2.466,0,0,1-1.189-.327,4.489,4.489,0,0,0,.059-.682l.149-.059a1.5,1.5,0,0,0,.95.415.921.921,0,0,0,.565-.177.708.708,0,0,0,.266-.594.817.817,0,0,0-.5-.713c-.3-.177-.625-.326-.923-.5a1.231,1.231,0,0,1-.5-1.039,1.269,1.269,0,0,1,.5-1.1,1.72,1.72,0,0,1,1.04-.3,2.8,2.8,0,0,1,1.009.207l.03.059c0,.208-.03.416-.03.594l-.119.089a1.933,1.933,0,0,0-.89-.327.885.885,0,0,0-.535.149.587.587,0,0,0-.267.505.853.853,0,0,0,.536.682c.3.149.622.327.949.476A1.266,1.266,0,0,1,80.7,58.3a1.417,1.417,0,0,1-.505,1.217,1.551,1.551,0,0,1-1.1.386",
    transform: "translate(14.715 10.355)",
    fill: "#1a1718"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9548",
    "data-name": "Path 9548",
    d: "M81.634,59.831c-.3,0-.535.03-.8.03.059-.861.088-1.6.088-2.139s-.029-1.009-.058-1.454a3.288,3.288,0,0,0,.712-.149l.089.059c-.059,1.277-.089,2.494-.03,3.652m-.03-4.276-.089.089c-.089,0-.267.059-.535.089.03-.238.089-.594.149-1.069.149-.03.416-.03.8-.059Z",
    transform: "translate(15.267 10.313)",
    fill: "#1a1718"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9549",
    "data-name": "Path 9549",
    d: "M84.226,59.611l-.059-.089c0-.208,0-.565.03-1.1v-1.1a.894.894,0,0,0-.119-.535c-.089-.149-.178-.238-.327-.238a1.12,1.12,0,0,0-.742.327c-.03,1.009-.03,1.9,0,2.613l-.059.059a6.793,6.793,0,0,0-.743.059c.059-1.009.059-1.752.059-2.2,0-.357-.03-.8-.059-1.278a.46.46,0,0,1,.178-.089,1.672,1.672,0,0,1,.505.178,2.01,2.01,0,0,1,1.128-.3c.594,0,.892.355.892,1.1.03.208,0,.5,0,.92v.892a6.215,6.215,0,0,0,.03.712c-.267.03-.505.03-.713.059",
    transform: "translate(15.526 10.563)",
    fill: "#1a1718"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9550",
    "data-name": "Path 9550",
    d: "M87.435,56.671l-.119.059a.959.959,0,0,0-.535-.178.847.847,0,0,0-.742.416,1.627,1.627,0,0,0-.267.95,1.569,1.569,0,0,0,.208.773.7.7,0,0,0,.624.355,1.337,1.337,0,0,0,.861-.474c0,.355-.03.623-.03.772a1.239,1.239,0,0,1-.95.327,1.288,1.288,0,0,1-1.1-.535,2.039,2.039,0,0,1-.355-1.217,2.336,2.336,0,0,1,.415-1.366,1.52,1.52,0,0,1,1.248-.623,2.23,2.23,0,0,1,.772.147c0,.238-.03.416-.03.594",
    transform: "translate(16.06 10.563)",
    fill: "#1a1718"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9551",
    "data-name": "Path 9551",
    d: "M89.906,57.422c-.385.119-1.009.327-1.812.565.059.712.357,1.1.892,1.1a1.246,1.246,0,0,0,.476-.119,3.231,3.231,0,0,0,.564-.474c-.03.326-.03.623-.059.831a1.1,1.1,0,0,1-.534.3,1.737,1.737,0,0,1-.535.059,1.41,1.41,0,0,1-1.1-.416,1.758,1.758,0,0,1-.446-1.277,2.464,2.464,0,0,1,.327-1.455,1.262,1.262,0,0,1,1.158-.654,1.414,1.414,0,0,1,.831.3,2.133,2.133,0,0,1,.505.892c-.059.089-.149.207-.267.355m-1.1-.98q-.49,0-.713.89l1.278-.355c-.208-.357-.386-.535-.565-.535",
    transform: "translate(16.498 10.553)",
    fill: "#1a1718"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9552",
    "data-name": "Path 9552",
    d: "M79.456,63.062c0,.98.03,1.723.059,2.227a8.035,8.035,0,0,0-.831.03c0-1.781.03-3.206,0-4.276-.178.03-.357.089-.535.119L78.06,61.1c0-.207.03-.355.03-.5l.03-.089c.446-.059.861-.119,1.307-.208l.089.059c-.03.476-.059,1.4-.059,2.7",
    transform: "translate(14.743 11.389)",
    fill: "#1a1718"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9553",
    "data-name": "Path 9553",
    d: "M81.211,65.343a2.164,2.164,0,0,1-.92-.208l-.03-.059c0-.178.03-.386.03-.593l.119-.059a1.21,1.21,0,0,0,.772.3c.654,0,1.07-.534,1.217-1.6a1.523,1.523,0,0,1-1.009.415,1.187,1.187,0,0,1-.98-.445,1.508,1.508,0,0,1-.327-1.04,1.761,1.761,0,0,1,.386-1.158,1.478,1.478,0,0,1,1.188-.565,1.277,1.277,0,0,1,1.188.654,2.717,2.717,0,0,1,.357,1.515,3.874,3.874,0,0,1-.446,1.99,1.722,1.722,0,0,1-1.544.861m.416-4.366a.723.723,0,0,0-.594.327,1.237,1.237,0,0,0-.207.682,1.042,1.042,0,0,0,.177.624.613.613,0,0,0,.505.3.881.881,0,0,0,.861-.654.669.669,0,0,0,.03-.208,1.576,1.576,0,0,0-.237-.772.709.709,0,0,0-.535-.3",
    transform: "translate(15.125 11.393)",
    fill: "#1a1718"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9554",
    "data-name": "Path 9554",
    d: "M86.562,63.989h-.534v1.188l-.059.089a4.6,4.6,0,0,0-.654.03l-.059-.089c0-.327,0-.743.03-1.217l-1.93.059v-.535a2.061,2.061,0,0,1,.266-.505l.267-.474c.238-.446.624-1.1,1.128-2.02l.059-.059c.238,0,.565-.03,1.011-.03-.03,1.009-.059,1.99-.059,2.91a4.169,4.169,0,0,0,.593-.03c0,.178-.03.386-.059.684m-2.405-.594,1.158-.03.03-2.02Z",
    transform: "translate(15.744 11.412)",
    fill: "#1a1718"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9555",
    "data-name": "Path 9555",
    d: "M89.914,63.989H89.38a7.877,7.877,0,0,0,0,1.188l-.059.089a4.6,4.6,0,0,0-.654.03l-.059-.089c0-.327,0-.743.03-1.217l-1.959.059c.03-.327.03-.505.03-.535a1.329,1.329,0,0,1,.266-.505l.267-.474c.238-.446.624-1.1,1.128-2.02l.059-.059c.238,0,.565-.03,1.011-.03-.03,1.009-.059,1.99-.059,2.91a4.382,4.382,0,0,0,.593-.03c-.03.178-.03.386-.059.684m-2.405-.594,1.128-.03.059-2.02Z",
    transform: "translate(16.371 11.412)",
    fill: "#1a1718"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9556",
    "data-name": "Path 9556",
    d: "M1.829,17.456a.548.548,0,0,0,.505-.535.527.527,0,0,0-.505-.534.527.527,0,0,0-.505.534.548.548,0,0,0,.505.535",
    transform: "translate(0.25 3.095)",
    fill: "#1a1718"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9557",
    "data-name": "Path 9557",
    d: "M5.975,17.451a.548.548,0,0,0,.505-.535.505.505,0,0,0-1.011,0,.548.548,0,0,0,.505.535",
    transform: "translate(1.033 3.099)",
    fill: "#1a1718"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9558",
    "data-name": "Path 9558",
    d: "M13.453,18.925a1.687,1.687,0,0,0-1.485-.654,1.722,1.722,0,0,0-1.485.654A2.606,2.606,0,0,0,10.1,20.44v.327c0,.682-.326,1.009-.98,1.009H8.464c-.653,0-.98-.327-.98-1.009V18.035l-.92.3v2.406c0,.682-.3,1.039-.951,1.039H5.2v-.03H3.891v-1.96a1.638,1.638,0,0,0-.535-1.277,2.2,2.2,0,0,0-1.4-.474,2.072,2.072,0,0,0-1.336.593v1.1a1.508,1.508,0,0,1,1.336-.861.887.887,0,0,1,1.009.98v1.931H.565L0,22.607H5.672a1.742,1.742,0,0,0,1.366-.534,1.747,1.747,0,0,0,1.367.534h.772a1.861,1.861,0,0,0,1.455-.534,1.721,1.721,0,0,0,1.336.534,1.705,1.705,0,0,0,1.485-.682,2.576,2.576,0,0,0,.416-1.485,2.609,2.609,0,0,0-.416-1.515m-1.485,2.851c-.624,0-.95-.446-.95-1.336,0-.92.326-1.366.95-1.366.654,0,.95.446.95,1.366,0,.89-.3,1.336-.95,1.336",
    transform: "translate(0 3.406)",
    fill: "#1a1718"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9559",
    "data-name": "Path 9559",
    d: "M1.119,28.168.524,27.93V23.505h.594Z",
    transform: "translate(0.099 4.439)",
    fill: "#1a1718"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9560",
    "data-name": "Path 9560",
    d: "M4.448,25.049V27.93l-.624.238v-1.6a1.2,1.2,0,0,1-.654.178,1.175,1.175,0,0,1-1.009-.505,2.075,2.075,0,0,1-.238-1.1,2.121,2.121,0,0,1,.238-1.128A1.175,1.175,0,0,1,3.17,23.5a1.134,1.134,0,0,1,.981.476,1.747,1.747,0,0,1,.3,1.069m-.624.089c0-.713-.208-1.039-.654-1.039s-.653.326-.653,1.039c0,.654.208,1.009.653,1.009s.654-.355.654-1.009",
    transform: "translate(0.363 4.439)",
    fill: "#1a1718"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9561",
    "data-name": "Path 9561",
    d: "M7.848,28.168h-1.4a1.274,1.274,0,0,1-.92-.357A1.412,1.412,0,0,1,5.146,26.8a1.264,1.264,0,0,1,.505-1.1,1.152,1.152,0,0,1-.416-.951,1.231,1.231,0,0,1,.357-.92,1.184,1.184,0,0,1,.861-.327H7.4v.565h-.95c-.416,0-.624.238-.624.682a.6.6,0,0,0,.654.684h.653v.593H6.482c-.476,0-.713.267-.713.773a.657.657,0,0,0,.684.742H7.581Z",
    transform: "translate(0.972 4.439)",
    fill: "#1a1718"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9562",
    "data-name": "Path 9562",
    d: "M11.22,28.168h-1.4a1.274,1.274,0,0,1-.92-.357A1.412,1.412,0,0,1,8.518,26.8a1.264,1.264,0,0,1,.505-1.1,1.152,1.152,0,0,1-.416-.951,1.231,1.231,0,0,1,.357-.92,1.184,1.184,0,0,1,.861-.327h.95v.565h-.95c-.416,0-.624.238-.624.682a.6.6,0,0,0,.654.684h.654v.593H9.854c-.476,0-.713.267-.713.773a.657.657,0,0,0,.684.742h1.128Z",
    transform: "translate(1.609 4.439)",
    fill: "#1a1718"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9563",
    "data-name": "Path 9563",
    d: "M16.986,32.244A2.628,2.628,0,1,1,19.6,34.887a2.623,2.623,0,0,1-2.613-2.643",
    transform: "translate(3.208 5.59)",
    fill: "#1a1718"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9564",
    "data-name": "Path 9564",
    d: "M40.547,63.365a.6.6,0,0,1-.564.624H37.578a.648.648,0,0,1-.623-.624V57.6a.622.622,0,0,1,.623-.594h2.406a.57.57,0,0,1,.564.594ZM45.359,67.7a.578.578,0,0,1-.594.594h-7.81a4.843,4.843,0,0,1-4.782-4.811V57.455a4.818,4.818,0,0,1,4.782-4.782h3.029a.569.569,0,0,0,.564-.593V50.417a.579.579,0,0,0-.564-.624h-6a.6.6,0,0,1-.594-.593V46.081a.577.577,0,0,1,.594-.593h6.563a4.791,4.791,0,0,1,4.811,4.81Z",
    transform: "translate(6.077 8.591)",
    fill: "#d70d1b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9565",
    "data-name": "Path 9565",
    d: "M53.691,64.512a.621.621,0,0,1-.593.623H50.692a.62.62,0,0,1-.593-.623V51.564a.6.6,0,0,1,.593-.624H53.1a.6.6,0,0,1,.593.624Zm-8.4-13.067A4.792,4.792,0,0,1,50.1,46.633h3a.6.6,0,0,0,.593-.593v-6a.622.622,0,0,1,.594-.624h3.622a.644.644,0,0,1,.594.624V68.848a.615.615,0,0,1-.594.593H50.1a4.829,4.829,0,0,1-4.811-4.81Z",
    transform: "translate(8.553 7.444)",
    fill: "#d70d1b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9566",
    "data-name": "Path 9566",
    d: "M72.875,63.365a.621.621,0,0,1-.593.624H69.876a.622.622,0,0,1-.593-.624V57.6a.6.6,0,0,1,.593-.594h2.406a.6.6,0,0,1,.593.594ZM77.657,67.7a.6.6,0,0,1-.594.594h-7.78a4.83,4.83,0,0,1-4.811-4.811V57.455a4.8,4.8,0,0,1,4.811-4.782h3a.594.594,0,0,0,.593-.593V50.417a.6.6,0,0,0-.593-.624h-6a.6.6,0,0,1-.594-.593V46.081a.577.577,0,0,1,.594-.593h6.592a4.8,4.8,0,0,1,4.782,4.81Z",
    transform: "translate(12.177 8.591)",
    fill: "#d70d1b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9567",
    "data-name": "Path 9567",
    d: "M58.4,46.081A.616.616,0,0,1,59,45.487h3.651a.612.612,0,0,1,.565.594V67.7a.615.615,0,0,1-.594.593H59A.615.615,0,0,1,58.4,67.7Z",
    transform: "translate(11.03 8.591)",
    fill: "#d70d1b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9568",
    "data-name": "Path 9568",
    d: "M34.236,57.4C30.524,53.84,18.2,52.563,18.2,47.575c0-3.89,6.653-5.969,11.582-5.969,1.782,0,5.4.3,5.761.3a.579.579,0,0,0,.654-.594V37.745a.6.6,0,0,0-.505-.594,39.88,39.88,0,0,0-5.613-.357c-8.434,0-16.689,4.1-16.689,11.108,0,8.731,14.461,9.77,17.788,13.1a2.437,2.437,0,0,1,.059,3.772c-.446.446-1.247,1.069-3.474,1.069-3.3,0-8.227-2.465-9.682-3.237a.573.573,0,0,0-.8.238c-.03.03-1.812,3.3-1.812,3.3a.631.631,0,0,0,.238.8c2.108,1.04,7.839,3.713,11.76,3.713,4.247,0,6-1.307,7.424-2.762,2.405-2.406,3.206-6.8-.654-10.483",
    transform: "translate(2.529 6.949)",
    fill: "#1a1718"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9569",
    "data-name": "Path 9569",
    d: "M58.2,41.891A2.643,2.643,0,1,1,60.845,44.5,2.655,2.655,0,0,1,58.2,41.891",
    transform: "translate(10.993 7.407)",
    fill: "#1a1718"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9570",
    "data-name": "Path 9570",
    d: "M40.392,8.643H33.8a.6.6,0,0,0-.594.594v3.117a.616.616,0,0,0,.594.594h6a.6.6,0,0,1,.594.624V26.551a.6.6,0,0,1-.594.593H30.949a.623.623,0,0,0-.624.594v3.117a.586.586,0,0,0,.624.594H44.58a.6.6,0,0,0,.594-.594v-17.4a4.8,4.8,0,0,0-4.782-4.811",
    transform: "translate(5.728 1.632)",
    fill: "#d70d1b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9571",
    "data-name": "Path 9571",
    d: "M81.94,28.45V10.958a.6.6,0,0,0-.594-.593H77.724a.577.577,0,0,0-.594.593V28.034a.669.669,0,0,1-.385.416H73.863a.608.608,0,0,1-.416-.565V10.928a.615.615,0,0,0-.594-.593H69.23a.6.6,0,0,0-.594.593v16.9a.643.643,0,0,1-.445.624H65.785a.656.656,0,0,1-.415-.624v-16.9a.615.615,0,0,0-.594-.593H61.153a.6.6,0,0,0-.594.593V28.063a.623.623,0,0,1-.386.386h-9.83a.639.639,0,0,1-.594-.594V.593A.589.589,0,0,0,49.185,0H45.531a.559.559,0,0,0-.564.535V28.45h-.03l.03.059V28.6c.059.772.623,4.574,4.366,4.574H77.545c4.039,0,4.366-4.4,4.4-4.722",
    transform: "translate(8.488 0)",
    fill: "#d70d1b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9572",
    "data-name": "Path 9572",
    d: "M19.968,28.45h0a.639.639,0,0,1-.594-.594V.593A.57.57,0,0,0,18.81,0H15.156a.579.579,0,0,0-.564.535V28.45h-.03s.03,0,.03.059V28.6c.059.772.623,4.574,4.366,4.574h8.077c4.009,0,4.366-4.4,4.366-4.722h0V10.958a.571.571,0,0,0-.565-.593H27.184a.571.571,0,0,0-.565.593V28.034a.644.644,0,0,1-.415.416Z",
    transform: "translate(2.751 0)",
    fill: "#d70d1b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9573",
    "data-name": "Path 9573",
    d: "M22.082,32.244a2.628,2.628,0,1,1,2.643,2.643,2.63,2.63,0,0,1-2.643-2.643",
    transform: "translate(4.171 5.59)",
    fill: "#1a1718"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2252",
    "data-name": "Group 2252",
    transform: "translate(1575.664 3805.452)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2251",
    "data-name": "Group 2251",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2250",
    "data-name": "Group 2250",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2249",
    "data-name": "Group 2249",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2164",
    "data-name": "Group 2164",
    transform: "translate(38.094 86.494)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2163",
    "data-name": "Group 2163"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2162",
    "data-name": "Group 2162",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_852",
    "data-name": "Rectangle 852",
    width: 31.033,
    height: 8.077,
    transform: "translate(0 0.001)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_9506",
    "data-name": "Path 9506",
    d: "M36.047,73.241a3.46,3.46,0,1,1-3.475,3.445,3.448,3.448,0,0,1,3.475-3.445",
    transform: "translate(6.152 13.832)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9507",
    "data-name": "Path 9507",
    d: "M42.437,73.241a3.46,3.46,0,1,1-3.445,3.445,3.454,3.454,0,0,1,3.445-3.445",
    transform: "translate(7.364 13.832)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9508",
    "data-name": "Path 9508",
    d: "M48.862,73.241a3.46,3.46,0,1,1-3.475,3.445,3.448,3.448,0,0,1,3.475-3.445",
    transform: "translate(8.572 13.832)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9509",
    "data-name": "Path 9509",
    d: "M55.252,73.241a3.46,3.46,0,1,1-3.445,3.445,3.454,3.454,0,0,1,3.445-3.445",
    transform: "translate(9.785 13.832)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2167",
    "data-name": "Group 2167",
    transform: "translate(38.101 94.555)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2166",
    "data-name": "Group 2166"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2165",
    "data-name": "Group 2165",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9510",
    "data-name": "Path 9510",
    d: "M32.048,79.534v4.009a15.516,15.516,0,1,0,31.033,0V79.534Z",
    transform: "translate(-32.048 -79.534)",
    fill: "#040504",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_9511",
    "data-name": "Path 9511",
    d: "M41.573,81.907h1.485v5.761c0,2.079-1.6,3.148-3.564,3.148a3.216,3.216,0,0,1-3.474-3.089V85.471h1.4V87.52c0,1.188.861,1.842,2.108,1.842a1.883,1.883,0,0,0,2.05-1.812Z",
    transform: "translate(6.803 15.469)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9512",
    "data-name": "Path 9512",
    d: "M42.715,82.107h1.513l1.366,5.286s.03.238.178.238c.208,0,.208-.238.208-.238V82.107H47.5v4.544c0,.98,0,.98,1.04.98h6.206s.089-2.465-1.99-2.465c-1.009,0-1.515.623-1.515,1.158H49.692s-.058-2.465,2.94-2.465c3.12,0,3.713,2.465,3.713,5.137h-7.81c-1.189,0-1.248-.623-1.486-.623S46.842,89,45.8,89H42.715l.594-1.425h.8Z",
    transform: "translate(8.067 15.507)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2170",
    "data-name": "Group 2170",
    transform: "translate(92.625 65.185)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2169",
    "data-name": "Group 2169"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2168",
    "data-name": "Group 2168",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9513",
    "data-name": "Path 9513",
    d: "M79.1,59.908a2.466,2.466,0,0,1-1.189-.327,4.489,4.489,0,0,0,.059-.682l.149-.059a1.5,1.5,0,0,0,.95.415.921.921,0,0,0,.565-.177.708.708,0,0,0,.266-.594.817.817,0,0,0-.5-.713c-.3-.177-.625-.326-.923-.5a1.231,1.231,0,0,1-.5-1.039,1.269,1.269,0,0,1,.5-1.1,1.72,1.72,0,0,1,1.04-.3,2.8,2.8,0,0,1,1.009.207l.03.059c0,.208-.03.416-.03.594l-.119.089a1.933,1.933,0,0,0-.89-.327.885.885,0,0,0-.535.149.587.587,0,0,0-.267.505.853.853,0,0,0,.536.682c.3.149.622.327.949.476A1.266,1.266,0,0,1,80.7,58.3a1.417,1.417,0,0,1-.505,1.217,1.551,1.551,0,0,1-1.1.386",
    transform: "translate(-77.91 -54.829)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2173",
    "data-name": "Group 2173",
    transform: "translate(96.099 64.917)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2172",
    "data-name": "Group 2172"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2171",
    "data-name": "Group 2171",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9514",
    "data-name": "Path 9514",
    d: "M81.634,59.831c-.3,0-.535.03-.8.03.059-.861.088-1.6.088-2.139s-.029-1.009-.058-1.454a3.288,3.288,0,0,0,.712-.149l.089.059c-.059,1.277-.089,2.494-.03,3.652m-.03-4.276-.089.089c-.089,0-.267.059-.535.089.03-.238.089-.594.149-1.069.149-.03.416-.03.8-.059Z",
    transform: "translate(-80.833 -54.605)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2176",
    "data-name": "Group 2176",
    transform: "translate(97.733 66.491)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2175",
    "data-name": "Group 2175"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2174",
    "data-name": "Group 2174",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9515",
    "data-name": "Path 9515",
    d: "M84.226,59.611l-.059-.089c0-.208,0-.565.03-1.1v-1.1a.894.894,0,0,0-.119-.535c-.089-.149-.178-.238-.327-.238a1.12,1.12,0,0,0-.742.327c-.03,1.009-.03,1.9,0,2.613l-.059.059a6.793,6.793,0,0,0-.743.059c.059-1.009.059-1.752.059-2.2,0-.357-.03-.8-.059-1.278a.46.46,0,0,1,.178-.089,1.672,1.672,0,0,1,.505.178,2.01,2.01,0,0,1,1.128-.3c.594,0,.892.355.892,1.1.03.208,0,.5,0,.92v.892a6.213,6.213,0,0,0,.03.712c-.267.03-.505.03-.713.059",
    transform: "translate(-82.207 -55.929)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2179",
    "data-name": "Group 2179",
    transform: "translate(101.089 66.491)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2178",
    "data-name": "Group 2178"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2177",
    "data-name": "Group 2177",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9516",
    "data-name": "Path 9516",
    d: "M87.435,56.671l-.119.059a.959.959,0,0,0-.535-.178.847.847,0,0,0-.742.416,1.627,1.627,0,0,0-.267.95,1.569,1.569,0,0,0,.208.773.7.7,0,0,0,.624.355,1.337,1.337,0,0,0,.861-.474c0,.355-.03.623-.03.772a1.239,1.239,0,0,1-.95.327,1.288,1.288,0,0,1-1.1-.535,2.039,2.039,0,0,1-.355-1.217,2.336,2.336,0,0,1,.415-1.366,1.52,1.52,0,0,1,1.248-.623,2.23,2.23,0,0,1,.772.147c0,.238-.03.416-.03.594",
    transform: "translate(-85.029 -55.929)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2182",
    "data-name": "Group 2182",
    transform: "translate(103.846 66.432)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2181",
    "data-name": "Group 2181"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2180",
    "data-name": "Group 2180",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9517",
    "data-name": "Path 9517",
    d: "M89.906,57.422c-.385.119-1.009.327-1.812.565.059.712.357,1.1.892,1.1a1.246,1.246,0,0,0,.476-.119,3.231,3.231,0,0,0,.564-.474c-.03.326-.03.623-.059.831a1.1,1.1,0,0,1-.534.3,1.737,1.737,0,0,1-.535.059,1.411,1.411,0,0,1-1.1-.416,1.758,1.758,0,0,1-.446-1.277,2.464,2.464,0,0,1,.327-1.455,1.262,1.262,0,0,1,1.158-.654,1.414,1.414,0,0,1,.831.3,2.133,2.133,0,0,1,.505.892c-.059.089-.149.207-.267.355m-1.1-.98q-.49,0-.713.89l1.278-.355c-.208-.357-.386-.535-.565-.535",
    transform: "translate(-87.349 -55.879)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2185",
    "data-name": "Group 2185",
    transform: "translate(92.803 71.688)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2184",
    "data-name": "Group 2184"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2183",
    "data-name": "Group 2183",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9518",
    "data-name": "Path 9518",
    d: "M79.456,63.062c0,.98.03,1.723.059,2.227a8.035,8.035,0,0,0-.831.03c0-1.781.03-3.206,0-4.276-.178.03-.357.089-.535.119L78.06,61.1c0-.207.03-.355.03-.5l.03-.089c.446-.059.861-.119,1.307-.208l.089.059c-.03.476-.059,1.4-.059,2.7",
    transform: "translate(-78.06 -60.3)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2188",
    "data-name": "Group 2188",
    transform: "translate(95.209 71.718)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2187",
    "data-name": "Group 2187"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2186",
    "data-name": "Group 2186",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9519",
    "data-name": "Path 9519",
    d: "M81.211,65.343a2.164,2.164,0,0,1-.92-.208l-.03-.059c0-.178.03-.386.03-.593l.119-.059a1.21,1.21,0,0,0,.772.3c.654,0,1.07-.534,1.217-1.6a1.523,1.523,0,0,1-1.009.415,1.187,1.187,0,0,1-.98-.445,1.508,1.508,0,0,1-.327-1.04,1.761,1.761,0,0,1,.386-1.158,1.478,1.478,0,0,1,1.188-.565,1.277,1.277,0,0,1,1.188.654,2.717,2.717,0,0,1,.357,1.515,3.874,3.874,0,0,1-.446,1.99,1.722,1.722,0,0,1-1.544.861m.416-4.366a.723.723,0,0,0-.594.327,1.237,1.237,0,0,0-.207.682,1.042,1.042,0,0,0,.177.624.613.613,0,0,0,.505.3.881.881,0,0,0,.861-.654.669.669,0,0,0,.03-.208,1.576,1.576,0,0,0-.237-.772.709.709,0,0,0-.535-.3",
    transform: "translate(-80.084 -60.325)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2191",
    "data-name": "Group 2191",
    transform: "translate(99.099 71.837)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2190",
    "data-name": "Group 2190"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2189",
    "data-name": "Group 2189",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9520",
    "data-name": "Path 9520",
    d: "M86.562,63.989h-.534v1.188l-.059.089a4.6,4.6,0,0,0-.654.03l-.059-.089c0-.327,0-.743.03-1.217l-1.93.059v-.535a2.061,2.061,0,0,1,.266-.505l.267-.474c.238-.446.624-1.1,1.128-2.02l.059-.059c.238,0,.565-.03,1.011-.03-.03,1.009-.059,1.99-.059,2.91a4.168,4.168,0,0,0,.593-.03c0,.178-.03.386-.059.684m-2.405-.594,1.158-.03.03-2.02Z",
    transform: "translate(-83.356 -60.425)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2194",
    "data-name": "Group 2194",
    transform: "translate(103.048 71.837)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2193",
    "data-name": "Group 2193"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2192",
    "data-name": "Group 2192",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9521",
    "data-name": "Path 9521",
    d: "M89.914,63.989H89.38a7.875,7.875,0,0,0,0,1.188l-.059.089a4.6,4.6,0,0,0-.654.03l-.059-.089c0-.327,0-.743.03-1.217l-1.959.059c.03-.327.03-.505.03-.535a1.329,1.329,0,0,1,.266-.505l.267-.474c.238-.446.624-1.1,1.128-2.02l.059-.059c.238,0,.565-.03,1.011-.03-.03,1.009-.059,1.99-.059,2.91a4.381,4.381,0,0,0,.593-.03c-.03.178-.03.386-.059.684m-2.405-.594,1.128-.03.059-2.02Z",
    transform: "translate(-86.678 -60.425)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2197",
    "data-name": "Group 2197",
    transform: "translate(1.574 19.481)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2196",
    "data-name": "Group 2196"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2195",
    "data-name": "Group 2195",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9522",
    "data-name": "Path 9522",
    d: "M1.829,17.456a.548.548,0,0,0,.505-.535.527.527,0,0,0-.505-.534.527.527,0,0,0-.505.534.548.548,0,0,0,.505.535",
    transform: "translate(-1.324 -16.386)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2200",
    "data-name": "Group 2200",
    transform: "translate(6.504 19.511)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2199",
    "data-name": "Group 2199"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2198",
    "data-name": "Group 2198",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9523",
    "data-name": "Path 9523",
    d: "M5.975,17.451a.548.548,0,0,0,.505-.535.505.505,0,0,0-1.011,0,.548.548,0,0,0,.505.535",
    transform: "translate(-5.471 -16.411)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2203",
    "data-name": "Group 2203",
    transform: "translate(0 21.441)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2202",
    "data-name": "Group 2202"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2201",
    "data-name": "Group 2201",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9524",
    "data-name": "Path 9524",
    d: "M13.453,18.925a1.687,1.687,0,0,0-1.485-.654,1.722,1.722,0,0,0-1.485.654A2.606,2.606,0,0,0,10.1,20.44v.327c0,.682-.326,1.009-.98,1.009H8.464c-.653,0-.98-.327-.98-1.009V18.035l-.92.3v2.406c0,.682-.3,1.039-.951,1.039H5.2v-.03H3.891v-1.96a1.638,1.638,0,0,0-.535-1.277,2.2,2.2,0,0,0-1.4-.474,2.072,2.072,0,0,0-1.336.593v1.1a1.508,1.508,0,0,1,1.336-.861.887.887,0,0,1,1.009.98v1.931H.565L0,22.607H5.672a1.742,1.742,0,0,0,1.366-.534,1.747,1.747,0,0,0,1.367.534h.772a1.861,1.861,0,0,0,1.455-.534,1.721,1.721,0,0,0,1.336.534,1.705,1.705,0,0,0,1.485-.682,2.576,2.576,0,0,0,.416-1.485,2.609,2.609,0,0,0-.416-1.515m-1.485,2.851c-.624,0-.95-.446-.95-1.336,0-.92.326-1.366.95-1.366.654,0,.95.446.95,1.366,0,.89-.3,1.336-.95,1.336",
    transform: "translate(0 -18.035)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2206",
    "data-name": "Group 2206",
    transform: "translate(0.624 27.945)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2205",
    "data-name": "Group 2205"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2204",
    "data-name": "Group 2204",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9525",
    "data-name": "Path 9525",
    d: "M1.119,28.168.524,27.93V23.505h.594Z",
    transform: "translate(-0.525 -23.506)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2209",
    "data-name": "Group 2209",
    transform: "translate(2.287 27.945)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2208",
    "data-name": "Group 2208"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2207",
    "data-name": "Group 2207",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9526",
    "data-name": "Path 9526",
    d: "M4.448,25.049V27.93l-.624.238v-1.6a1.2,1.2,0,0,1-.654.178,1.175,1.175,0,0,1-1.009-.505,2.075,2.075,0,0,1-.238-1.1,2.121,2.121,0,0,1,.238-1.128A1.175,1.175,0,0,1,3.17,23.5a1.134,1.134,0,0,1,.981.476,1.747,1.747,0,0,1,.3,1.069m-.624.089c0-.713-.208-1.039-.654-1.039s-.653.326-.653,1.039c0,.654.208,1.009.653,1.009s.654-.355.654-1.009",
    transform: "translate(-1.923 -23.506)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2212",
    "data-name": "Group 2212",
    transform: "translate(6.118 27.945)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2211",
    "data-name": "Group 2211"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2210",
    "data-name": "Group 2210",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9527",
    "data-name": "Path 9527",
    d: "M7.848,28.168h-1.4a1.274,1.274,0,0,1-.92-.357A1.412,1.412,0,0,1,5.146,26.8a1.264,1.264,0,0,1,.505-1.1,1.152,1.152,0,0,1-.416-.951,1.231,1.231,0,0,1,.357-.92,1.184,1.184,0,0,1,.861-.327H7.4v.565h-.95c-.416,0-.624.238-.624.682a.6.6,0,0,0,.654.684h.653v.593H6.482c-.476,0-.713.267-.713.773a.657.657,0,0,0,.684.742H7.581Z",
    transform: "translate(-5.146 -23.506)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2215",
    "data-name": "Group 2215",
    transform: "translate(10.127 27.945)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2214",
    "data-name": "Group 2214"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2213",
    "data-name": "Group 2213",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9528",
    "data-name": "Path 9528",
    d: "M11.22,28.168h-1.4a1.274,1.274,0,0,1-.92-.357A1.412,1.412,0,0,1,8.518,26.8a1.264,1.264,0,0,1,.505-1.1,1.152,1.152,0,0,1-.416-.951,1.231,1.231,0,0,1,.357-.92,1.184,1.184,0,0,1,.861-.327h.95v.565h-.95c-.416,0-.624.238-.624.682a.6.6,0,0,0,.654.684h.654v.593H9.854c-.476,0-.713.267-.713.773a.657.657,0,0,0,.684.742h1.128Z",
    transform: "translate(-8.518 -23.506)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2218",
    "data-name": "Group 2218",
    transform: "translate(20.194 35.191)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2217",
    "data-name": "Group 2217"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2216",
    "data-name": "Group 2216",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9529",
    "data-name": "Path 9529",
    d: "M16.986,32.244A2.628,2.628,0,1,1,19.6,34.887a2.623,2.623,0,0,1-2.613-2.643",
    transform: "translate(-16.986 -29.6)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2221",
    "data-name": "Group 2221",
    transform: "translate(38.25 54.078)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2220",
    "data-name": "Group 2220"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2219",
    "data-name": "Group 2219",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9530",
    "data-name": "Path 9530",
    d: "M40.547,63.365a.6.6,0,0,1-.564.624H37.578a.648.648,0,0,1-.623-.624V57.6a.622.622,0,0,1,.623-.594h2.406a.57.57,0,0,1,.564.594ZM45.359,67.7a.578.578,0,0,1-.594.594h-7.81a4.843,4.843,0,0,1-4.782-4.811V57.455a4.818,4.818,0,0,1,4.782-4.782h3.029a.569.569,0,0,0,.564-.593V50.417a.579.579,0,0,0-.564-.624h-6a.6.6,0,0,1-.594-.593V46.081a.577.577,0,0,1,.594-.593h6.563a4.791,4.791,0,0,1,4.811,4.81Z",
    transform: "translate(-32.173 -45.487)",
    fill: "#040504",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2224",
    "data-name": "Group 2224",
    transform: "translate(53.841 46.862)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2223",
    "data-name": "Group 2223"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2222",
    "data-name": "Group 2222",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9531",
    "data-name": "Path 9531",
    d: "M53.691,64.512a.621.621,0,0,1-.593.623H50.692a.62.62,0,0,1-.593-.623V51.564a.6.6,0,0,1,.593-.624H53.1a.6.6,0,0,1,.593.624Zm-8.4-13.067A4.792,4.792,0,0,1,50.1,46.633h3a.6.6,0,0,0,.593-.593v-6a.622.622,0,0,1,.594-.624h3.622a.644.644,0,0,1,.594.624V68.847a.615.615,0,0,1-.594.593H50.1a4.829,4.829,0,0,1-4.811-4.81Z",
    transform: "translate(-45.287 -39.417)",
    fill: "#040504",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2227",
    "data-name": "Group 2227",
    transform: "translate(76.648 54.078)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2226",
    "data-name": "Group 2226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2225",
    "data-name": "Group 2225",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9532",
    "data-name": "Path 9532",
    d: "M72.875,63.365a.621.621,0,0,1-.593.624H69.876a.622.622,0,0,1-.593-.624V57.6a.6.6,0,0,1,.593-.594h2.406a.6.6,0,0,1,.593.594ZM77.657,67.7a.6.6,0,0,1-.594.594h-7.78a4.83,4.83,0,0,1-4.811-4.811V57.455a4.8,4.8,0,0,1,4.811-4.782h3a.594.594,0,0,0,.593-.593V50.417a.6.6,0,0,0-.593-.624h-6a.6.6,0,0,1-.594-.593V46.081a.577.577,0,0,1,.594-.593h6.592a4.8,4.8,0,0,1,4.782,4.81Z",
    transform: "translate(-64.472 -45.487)",
    fill: "#040504",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2230",
    "data-name": "Group 2230",
    transform: "translate(69.432 54.078)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2229",
    "data-name": "Group 2229"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2228",
    "data-name": "Group 2228",
    clipPath: "url(#clip-path-27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9533",
    "data-name": "Path 9533",
    d: "M58.4,46.081A.616.616,0,0,1,59,45.487h3.651a.612.612,0,0,1,.565.594V67.7a.615.615,0,0,1-.594.593H59A.615.615,0,0,1,58.4,67.7Z",
    transform: "translate(-58.401 -45.487)",
    fill: "#040504",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2233",
    "data-name": "Group 2233",
    transform: "translate(15.918 43.743)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2232",
    "data-name": "Group 2232"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2231",
    "data-name": "Group 2231",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9534",
    "data-name": "Path 9534",
    d: "M34.236,57.4C30.524,53.84,18.2,52.563,18.2,47.575c0-3.89,6.653-5.969,11.582-5.969,1.782,0,5.4.3,5.761.3a.579.579,0,0,0,.654-.594V37.745a.6.6,0,0,0-.505-.594,39.881,39.881,0,0,0-5.613-.357c-8.434,0-16.689,4.1-16.689,11.108,0,8.731,14.461,9.77,17.788,13.1a2.437,2.437,0,0,1,.059,3.772c-.446.446-1.247,1.069-3.474,1.069-3.3,0-8.227-2.465-9.682-3.237a.573.573,0,0,0-.8.238c-.03.03-1.812,3.3-1.812,3.3a.631.631,0,0,0,.238.8c2.108,1.04,7.839,3.713,11.76,3.713,4.247,0,6-1.307,7.424-2.762,2.405-2.406,3.206-6.8-.654-10.483",
    transform: "translate(-13.389 -36.794)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2236",
    "data-name": "Group 2236",
    transform: "translate(69.194 46.624)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2235",
    "data-name": "Group 2235"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2234",
    "data-name": "Group 2234",
    clipPath: "url(#clip-path-29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9535",
    "data-name": "Path 9535",
    d: "M58.2,41.891A2.643,2.643,0,1,1,60.845,44.5,2.655,2.655,0,0,1,58.2,41.891",
    transform: "translate(-58.202 -39.217)",
    fill: "#040504"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2239",
    "data-name": "Group 2239",
    transform: "translate(36.052 10.275)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2238",
    "data-name": "Group 2238"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2237",
    "data-name": "Group 2237",
    clipPath: "url(#clip-path-30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9536",
    "data-name": "Path 9536",
    d: "M40.392,8.643H33.8a.6.6,0,0,0-.594.594v3.117a.616.616,0,0,0,.594.594h6a.6.6,0,0,1,.594.624V26.551a.6.6,0,0,1-.594.593H30.949a.623.623,0,0,0-.624.594v3.117a.586.586,0,0,0,.624.594h13.63a.6.6,0,0,0,.594-.594v-17.4a4.8,4.8,0,0,0-4.782-4.811",
    transform: "translate(-30.325 -8.643)",
    fill: "#040504",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2242",
    "data-name": "Group 2242",
    transform: "translate(53.425 0)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2241",
    "data-name": "Group 2241",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2240",
    "data-name": "Group 2240",
    clipPath: "url(#clip-path-31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9537",
    "data-name": "Path 9537",
    d: "M81.94,28.45V10.958a.6.6,0,0,0-.594-.593H77.723a.577.577,0,0,0-.594.593V28.033a.669.669,0,0,1-.385.416H73.863a.608.608,0,0,1-.416-.565V10.928a.615.615,0,0,0-.594-.593H69.23a.6.6,0,0,0-.594.593v16.9a.643.643,0,0,1-.445.624H65.785a.656.656,0,0,1-.415-.624v-16.9a.615.615,0,0,0-.594-.593H61.153a.6.6,0,0,0-.594.593V28.063a.623.623,0,0,1-.386.386h-9.83a.639.639,0,0,1-.594-.594V.593A.589.589,0,0,0,49.185,0H45.531a.559.559,0,0,0-.564.535V28.45h-.03l.03.059V28.6c.059.772.623,4.574,4.366,4.574H77.545c4.039,0,4.366-4.4,4.4-4.722",
    transform: "translate(-44.938 0)",
    fill: "#040504",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2245",
    "data-name": "Group 2245",
    transform: "translate(17.313 0)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2244",
    "data-name": "Group 2244",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2243",
    "data-name": "Group 2243",
    clipPath: "url(#clip-path-32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9538",
    "data-name": "Path 9538",
    d: "M19.968,28.45h0a.639.639,0,0,1-.594-.594V.593A.57.57,0,0,0,18.81,0H15.156a.579.579,0,0,0-.564.535V28.45h-.03s.03,0,.03.059V28.6c.059.772.623,4.574,4.366,4.574h8.077c4.009,0,4.366-4.4,4.366-4.722h0V10.958a.571.571,0,0,0-.565-.593H27.184a.571.571,0,0,0-.565.593V28.033a.644.644,0,0,1-.415.416Z",
    transform: "translate(-14.563 0)",
    fill: "#040504",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2248",
    "data-name": "Group 2248",
    transform: "translate(26.252 35.191)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2247",
    "data-name": "Group 2247"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2246",
    "data-name": "Group 2246",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9539",
    "data-name": "Path 9539",
    d: "M22.082,32.244a2.628,2.628,0,1,1,2.643,2.643,2.63,2.63,0,0,1-2.643-2.643",
    transform: "translate(-22.082 -29.6)",
    fill: "#040504"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrk5);
export default __webpack_public_path__ + "static/media/wrk-5.4b8d0e206207ec3e3643a9f2ba79e265.svg";
export { ForwardRef as ReactComponent };